import { API_URL, getCachedSessionId } from 'src/services/common';
import { FetchCustomTypesResponseData } from './interfaces/fetchCustomTypeData.interface';

import { api } from '../../../../util/axios-instance';

export const fetchCustomTypes = async (
  projectId: string
): Promise<FetchCustomTypesResponseData | undefined> => {
  const response = await api.get<FetchCustomTypesResponseData>(
    `${API_URL}/v1/project/${projectId}/customType`,
    {
      headers: { 'x-session-id': getCachedSessionId() }
    }
  );
  return response.data;
};
